// Whose chores the dashboard shows, remembered on this device so it opens the way it was left.
// Your own unless "Everyone" was picked last.
// The same as domain's ChoreView, which lib can't import.
type ChoreView = 'mine' | 'everyone';

const KEY = 'choreschamp.choreView';

export function loadChoreView(): ChoreView {
  try {
    return localStorage.getItem(KEY) === 'everyone' ? 'everyone' : 'mine';
  } catch {
    return 'mine';
  }
}

export function saveChoreView(view: ChoreView): void {
  try {
    localStorage.setItem(KEY, view);
  } catch {
    // Not remembered, then: the dashboard opens on your own chores next time.
  }
}
